"use client";

import React, { useCallback, useEffect, useState } from "react";
import { Skeleton } from "@/components/ui/skeleton";
import client from "@/lib/api/client";
import { _ } from "@/lib/api/i18n";
import { user_ref } from "@/lib/api/state";
import { useLayout } from "@/lib/context/layout";
import { useMenu } from "@/lib/context/menu";
import { AppMenuitem } from "./AppMenuitem";
import type { MenuItem } from "@/lib/api/types";

export const AppMenu = () => {
    const [model, setModel] = useState<{ loaded: boolean; menus: MenuItem[] }>({ loaded: false, menus: [] });
    const { refreshDashboards, setRefreshDashboards, setMenuData } = useLayout();

    const load_dashboards = useCallback(() => {
        client.get_dashboards().then((dbs: MenuItem[]) => {
            if (!dbs) return;
            setModel({ loaded: true, menus: dbs });
            setMenuData(dbs);
        });
    }, [setMenuData]);

    useEffect(() => {
        if (!model.loaded) {
            load_dashboards();
        }
    }, [model.loaded, load_dashboards]);

    useEffect(() => {
        if (refreshDashboards) {
            load_dashboards();
            setRefreshDashboards(false);
        }
    }, [refreshDashboards]);

    if (!model.loaded) {
        return (
            <div className="space-y-2 p-2">
                {[...Array(12)].map((_, i) => (
                    <Skeleton key={i} className="h-8 w-full rounded-lg" />
                ))}
            </div>
        );
    }

    if (!model.menus || model.menus.length === 0) {
        return <></>;
    }

    return (
        <ul className="layout-menu m-0 p-0 list-none select-none">
            {model.menus.map((item, i) => {
                return !item.seperator ? (
                    <AppMenuitem
                        item={item}
                        root={true}
                        index={i}
                        label={_(item.label || "")}
                        key={item.label + "i"}
                    />
                ) : (
                    <li key={`sep-${i}`} className="menu-separator my-2 border-t border-border" />
                );
            })}
        </ul>
    );
};
